/**
 * v3.21-1667 · Shared compact attention_color picker.
 *
 * Used both when creating a note (ClientWorkspaceModal) and when
 * editing an existing note (ClientDetailPage note surfaces).
 *
 * NEVER alters Deal lifecycle or financial fields — pure attention.
 */
import React from 'react';

const OPTIONS = [
  { v: 'neutral', label: 'Normal', cls: 'bg-slate-100 text-slate-700 border-slate-300' },
  { v: 'green',   label: 'Green',  cls: 'bg-emerald-100 text-emerald-800 border-emerald-400' },
  { v: 'yellow',  label: 'Yellow', cls: 'bg-amber-100 text-amber-800 border-amber-400' },
  { v: 'red',     label: 'Red',    cls: 'bg-red-100 text-red-800 border-red-400' },
];

export default function NoteAttentionPicker({
  value = 'neutral',
  onChange,
  testIdPrefix = 'note-color',
  compact = false,
}) {
  return (
    <div
      className="flex items-center gap-1.5 flex-wrap"
      data-testid={`${testIdPrefix}-picker`}
    >
      <span className="text-[10px] text-slate-500 uppercase tracking-wider">
        Attention:
      </span>
      {OPTIONS.map((o) => {
        const active = value === o.v;
        return (
          <button
            key={o.v}
            type="button"
            onClick={() => onChange && onChange(o.v)}
            className={`text-[10px] ${compact ? 'px-1.5 py-0.5' : 'px-2 py-0.5'} rounded border ${o.cls} ${
              active
                ? 'ring-2 ring-offset-1 ring-slate-400 font-semibold'
                : 'opacity-70 hover:opacity-100'
            }`}
            data-testid={`${testIdPrefix}-${o.v}`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
